export const LOUNGE = 'LOUNGE'
export const VIP = 'VIP'
export const CLUB = 'CLUB'
export const binRegex = /^\d{0,8}$/
export const gradientTextStyle = {
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    'background-clip': 'text',
    'text-fill-color': 'transparent'
}

export const bgGradient = {
    [CLUB]: 'linear-gradient(231deg, rgba(189, 189, 189, 0.4) -9.18%, rgba(237, 237, 237, 0.4) 108.59%)',
    [LOUNGE]: 'linear-gradient(231deg, rgba(214, 168, 116, 0.4) -9.18%, rgba(239, 201, 157, 0.4) 108.59%)',
    [VIP]: 'linear-gradient(255.32deg, rgba(61, 111, 160, 0.4) 59.7%, rgba(96, 160, 189, 0.4) 82.05%)'
}
export const textGradient = {
    [CLUB]: 'linear-gradient(231deg, #BDBDBD -9.18%, #EDEDED 108.59%)',
    [LOUNGE]: 'linear-gradient(231deg, #D6A874 -9.18%, #EFC99D 108.59%)',
    [VIP]: 'linear-gradient(255.78deg, #3D6FA0 55.25%, #60A0BD 82.56%)'
}
export const dividerGradient = {
    [CLUB]:
        'linear-gradient(90deg, transparent, transparent 50%, rgb(58, 29, 41) 50%, rgb(58, 29, 41) 100%), linear-gradient(255.32deg, #BDBDBD 59.7%, #EDEDED 82.05%)',
    [LOUNGE]:
        'linear-gradient(90deg, transparent, transparent 50%, rgb(58, 29, 41) 50%, rgb(58, 29, 41) 100%), linear-gradient(255.32deg, #D6A874 59.7%, #EFC99D 82.05%)',
    [VIP]:
        'linear-gradient(90deg, transparent, transparent 50%, rgb(58, 29, 41) 50%, rgb(58, 29, 41) 100%), linear-gradient(255.32deg, #3D6FA0 59.7%, #60A0BD 82.05%)'
}
export const borderColor = {
    [CLUB]: '#BDBDBD',
    [LOUNGE]: '#D6A874',
    [VIP]: '#3D6FA0'
}
export const membershipTitle = {
    [CLUB]: 'CLUB Member',
    [LOUNGE]: 'LOUNGE Member',
    [VIP]: 'VIP Member'
}

export const OfferType = {
    'HNI' : 'VIP',
    'AFFLUENT' : 'LOUNGE',
    'RETAIL' : 'CLUB'
}
 export const couponCodeType = {
    'HNI' : 'CTVIP',
    'AFFLUENT' : 'CTLOUNGE',
    'RETAIL' : 'CTCLUB'
 }

 export const includedCards = {
    'RETAIL': 'My Zone, Neo & more',
    'AFFLUENT': 'Select, Vistara & more',
    'HNI': 'Magnus, Burgundy & more'
}

export const loaderFccImage = 'data:image/webp;base64,UklGRjABAABXRUJQVlA4TCQBAAAvZ8EoAB+goG0bhj/h3h0a/ScboPj/3cJq/uMfyBCAXNu22kYOlKB+XELoCIwjj38JqiJUSMaqQiX8dECm/wL6Ct0wRfR/ApL7B4hNk3gfub3Yjp7t2IGe9DVA8L//vlN4ax0qCm0myFt0qGcec3pCrNZjHeU0XTJdNWp8h6Gciw6ZLoeuoTB0OShVDWGqCrwqB3NVQwiCHGaW0ZigIcEquFCUsbYhrBXB2jIOTVHGvAavagpzSTkXOQRJQ87g0CRNAbywuSZ3L2iqgEPTVANelAFzVRkEVTmYqiGNJm825aJlqKYxc6w1HZpVWGuuBjM7b0NOsGitZx6r9PjYUA8xBPm2qSJms9PT0xJJz/vff1+qDvSkr8GOnu1YX08vlhyoSZP7' 